/**
 * Standard industry box sizes
 */
export const IAB_SIZES = ["320x50", "300x250", "300x600", "728x90", "970x250"];

/**
 * Fancy sizes
 */
export const PREMIUM_SIZES = ["320x450", "970x350"];
